export default __webpack_public_path__ + "old_browser.html";